import { render, staticRenderFns } from "./Mine.vue?vue&type=template&id=f04b7802&scoped=true&"
import script from "./Mine.vue?vue&type=script&lang=js&"
export * from "./Mine.vue?vue&type=script&lang=js&"
import style0 from "./Mine.vue?vue&type=style&index=0&id=f04b7802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04b7802",
  null
  
)

export default component.exports